/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getTimezone, getTennisCompetitions, getFilterData, getTennisEventStatus,
} from '../../../selectors/common';


import {
  getTennisLastEventId, getTennisLastDate, getTennisEvents, getTennisTimeHeaders,
} from '../../../selectors/events';
import {
  SHOW_FILTERS,
  TENNIS_FILTERS_NAMES,
  TENNIS_FILTER_FIELDS,
  TENNIS_FILTER_SHOW_DROPDOWN,
} from '../../../constants';
import Events from '..';
import {
  aBookTennisEvents, aGetTennisEvents, aResetTennisEventDetails, aUnbookTennisEvents,
  aBulkBookTennisEvents, aBulkUnbookTennisEvents,
} from '../../../reducers';
import { aSetSelectedRowMatchId } from '../../../reducers/oddsHistory';

const mapToProps = (state) => ({
  filters: getFilterData(state),
  events: getTennisEvents(state),
  timeHeaders: getTennisTimeHeaders(state),
  lastEventId: getTennisLastEventId(state),
  lastDate: getTennisLastDate(state),
  getTimezone: getTimezone(state),
  competitions: getTennisCompetitions(state),
  tennisEventStatus: getTennisEventStatus(state),

});

const actionsToProps = (dispatch) => ({
  getEvents: (payload) => dispatch(aGetTennisEvents(payload)),
  setSelectedRowMatchId: (payload) => dispatch(aSetSelectedRowMatchId(payload)),
  bookEvents: (payload) => dispatch(aBookTennisEvents(payload)),
  unbookEvents: (payload) => dispatch(aUnbookTennisEvents(payload)),
  bulkBookEvents: (payload) => dispatch(aBulkBookTennisEvents(payload)),
  bulkUnbookEvents: (payload) => dispatch(aBulkUnbookTennisEvents(payload)),
  resetDetailsForEvents: (payload) => dispatch(aResetTennisEventDetails(payload)),

});

class TennisEvents extends Component {
  /* componentDidUpdate(prevProps){

  } */
  constructor(props) {
    super(props);
    /**
     * @member {Array}
     * @description Filtering fields settings
     */

    this.filterFields = [
      {
        text: TENNIS_FILTERS_NAMES.DATE,
        field: ['filterStartDate', 'filterEndDate'],
        dateInterval: true,
      },
      {
        text: TENNIS_FILTERS_NAMES.COMPETITION,
        field: 'filterCompetitions[]',
        filterLeague: 'filterCompetitions',
        selections: props.competitions.map((competition) => ({
          id: competition.id,
          label: competition.name,
        })),
      },
      {
        text: TENNIS_FILTERS_NAMES.MATCH_ID,
        field: 'filterMatchId',
        type: 'number',
      },
      {
        text: TENNIS_FILTERS_NAMES.PLAYER_NAME,
        field: 'filterPlayerName',
      },
      {
        text: TENNIS_FILTERS_NAMES.STATUS,
        field: 'filterStatus',
        dropdown: props.tennisEventStatus,
      },
      {
        text: TENNIS_FILTERS_NAMES.SHOW,
        field: 'filterShow',
        dropdown: TENNIS_FILTER_SHOW_DROPDOWN,
      },
      {
        text: TENNIS_FILTERS_NAMES.HIDE_ENDED_MATCHES,
        field: 'filterHideEndedMatches',
        checkbox: true,
      },
    ];

    this.defaultFilter = {
      startDate: '',
      endDate: '',
    };

    /**
     * @member {object}
     */
    this.state = {
      filters : props.filters ? { ...props.filters } : this.defaultFilter,
      selectedItem : {
        [TENNIS_FILTER_FIELDS.FILTER_COMP_ARRAY]: [],
        [TENNIS_FILTER_FIELDS.FILTER_STATUS_RANGE]: SHOW_FILTERS.ALL,
        [TENNIS_FILTER_FIELDS.FILTER_SHOW_RANGE]: SHOW_FILTERS.ALL,
      }};
    this.headersTable = [
      'Match ID', 'Date/Time', 'Status', 'Player 1', 'Player2', 'Score',
      'Competition', 'Tournamment ID', 'Round',
    ];
  }

  componentDidUpdate(prevProps) {
    if(prevProps.filters !== this.props.filters){
      this.setState({
        filters : { ...this.props.filters },
        selectedItem : {
          [TENNIS_FILTER_FIELDS.FILTER_COMP_ARRAY]: this.props.filters && this.props.filters['filterCompetitions[]'] ? [...this.props.filters['filterCompetitions[]']] : [],
          [TENNIS_FILTER_FIELDS.FILTER_STATUS_RANGE]: this.props.tennisEventStatus.find((status) => parseInt(status.id)
            === (Number.isNaN(parseInt(this.props.filters?.filterStatus)) ? SHOW_FILTERS.ALL : parseInt(this.props.filters.filterStatus))),
          [TENNIS_FILTER_FIELDS.FILTER_SHOW_RANGE]: TENNIS_FILTER_SHOW_DROPDOWN.find(((show) => show.id
            === (parseInt(this.props.filters?.filterShow) || SHOW_FILTERS.ALL))),
        }
      });
    }
  }

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <Events
        filtersParams={this.state.filters}
        selectedItem={this.state.selectedItem}
        defaultFilter={this.defaultFilter}
        filterFields={this.filterFields}
        getEvents={this.props.getEvents}
        bookEvents={this.props.bookEvents}
        unbookEvents={this.props.unbookEvents}
        bulkBookEvents={this.props.bulkBookEvents}
        bulkUnbookEvents={this.props.bulkUnbookEvents}
        resetDetailsForEvents={this.props.resetDetailsForEvents}
        events={this.props.events}
        timeHeaders={this.props.timeHeaders}
        leagues={this.props.competitions}
        lastEventId={this.props.lastEventId}
        lastDate={this.props.lastDate}
        headers={this.headersTable}
        isTennis
      />

    );
  }
}

export default connect(mapToProps, actionsToProps)(TennisEvents);
